import React, { HTMLAttributes, ReactElement } from 'react';
import { styled } from '@mui/material';

export type Props = {
  active: boolean,
  icon?: ReactElement,
} & HTMLAttributes<HTMLButtonElement>;

const Button = styled('button')(({ active }: { active: boolean }) => ({
  cursor: 'pointer',
  display: 'flex',
  gap: '5px',
  alignItems: 'center',
  fontSize: '14px',
  padding: '8px 14px',
  ...(active ? {
    background: '#FFFFFF',
    border: '1px solid #DFE1E6',
    borderRadius: '6px',
    color: '#091E42',

  } : {
    background: 'transparent',
    border: 'none',
    color: '#0747A6',
  })
}));

export default ({ active, icon, children, ...props }: Props) => {
  return <Button
    active={active}
    {...props}
  >
    {active && icon}
    {children}
  </Button>
};